<ng-template class="theme-modal" #quickView let-modal>
    <div class="modal-content quick-view-modal">
        <div class="modal-body quick-view-modal__body">
            <button type="button" class="close float-end border-0" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="row quick-view-layout g-0">
                <div class="col-lg-6 col-12 quick-view-media-col">
                    <div class="quick-view-img">
                        <img [src]="ImageSrc || product?.images?.[0]?.src"
                             [alt]="product?.images?.[0]?.alt || product?.title"
                             class="quick-view-img__photo">
                    </div>
                </div>
                <div class="col-lg-6 col-12 quick-view-info-col rtl-text">
                    <div class="product-right">
                        <h2>{{ product.title | titlecase }}</h2>
                        <h3>{{ product.price * currency?.price | discount:product | currency:currency?.currency:'symbol' }}
                            <del *ngIf="product?.discount"><span class="money">{{ product.price * currency?.price | currency:currency?.currency:'symbol' }}</span></del>
                        </h3>
                        <ul class="color-variant" *ngIf="Color(product.variants).length">
                            <li [class]="color" *ngFor="let color of Color(product.variants)"
                                [ngStyle]="{'background-color': color}" (click)="ChangeVariants(color, product)">
                            </li>
                        </ul>
                        <div class="border-product">
                            <h6 class="product-title">Detalles del producto</h6>
                            <div class="quick-view-detail-tables">
                                <div class="table-responsive">
                                    <table class="table mb-0 quick-view-spec-table">
                                        <tbody>
                                            <tr>
                                                <td>Descripción</td>
                                                <td>{{ displaySpec(product?.description || product?.title) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Marca</td>
                                                <td>{{ displaySpec(product?.brand) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Modelo</td>
                                                <td>{{ displaySpec(product?.modelo) }}</td>
                                            </tr>
                                            <tr>
                                                <td>SKU</td>
                                                <td>{{ displaySpec(product?.sku) }}</td>
                                            </tr>
                                            <tr>
                                                <td>UPC</td>
                                                <td>{{ displaySpec(product?.upc) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Unidad de medida</td>
                                                <td>{{ displaySpec(product?.unidadMedida) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="product-description border-product" *ngIf="Size(product.variants).length">
                            <div class="size-box">
                                <ul>
                                    <li *ngFor="let size of Size(product.variants)">
                                        <a href="javascript:void(0)">{{ size | titlecase }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="quick-view-modal__footer">
            <a href="javascript:void(0)" class="btn btn-solid" (click)="goToProductDetail(modal)">Ver detalle</a>
        </div>
    </div>
</ng-template>
